import { render } from "./VlogVideoDetail.vue?vue&type=template&id=e3b519d0&scoped=true"
import script from "./VlogVideoDetail.vue?vue&type=script&lang=js"
export * from "./VlogVideoDetail.vue?vue&type=script&lang=js"

import "./VlogVideoDetail.vue?vue&type=style&index=0&id=e3b519d0&scoped=true&lang=css"

import exportComponent from "E:\\workspace\\digital-gate\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3b519d0"]])

export default __exports__